import { Popconfirm } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import React from 'react';
import './style.scss';
type ConfirmProps = {
  placement?: TooltipPlacement;
  title: string;
  description: string;
  icon?: React.ReactNode;
  onConfirm(): any;
  children: React.ReactNode;
};

const Confirm: React.FC<ConfirmProps> = ({
  placement = 'top',
  title = '<Confirm title Here>',
  description = '<Confirm description here>',
  icon = <></>,
  onConfirm,
  children = <></>,
}) => {
  return (
    <div className='confirm-container'>
      <Popconfirm placement={placement} title={title} description={description} icon={icon} onConfirm={onConfirm}>
        {children}
      </Popconfirm>
    </div>
  );
};
export default Confirm;
